import * as React from 'react';
import * as ReactDom from 'react-dom';
import { useContext, useReducer, useState, useEffect } from "react";

import { MessagesContext } from "../common/context";
import { messagesReducer } from "../common/reducer";
import { convertToRaw} from "draft-js";
import draftToHtml from 'draftjs-to-html'; 
//import * as draftToHtml from 'draftjs-to-html';

import { Editor } from 'react-draft-wysiwyg';

import { EditorState, convertFromHTML, blocksFromHTML, ContentState} from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { PrimaryButton, DefaultButton } from "office-ui-fabric-react/lib/Button";
import { CONTENT_TYPE } from "../common/consts";

 
/**
 * getContentState - converts From HTML - Convert from Html to raw format of draftjs
 * @param contentRawHtml - As was dynamically generated from items
 * 
 */
const getContentState = (contentRawHtml)=>{  
    const blocksFromHTML = convertFromHTML(contentRawHtml);
    const contentState = ContentState.createFromBlockArray(
            blocksFromHTML.contentBlocks,
            blocksFromHTML.entityMap,
        )
    return (contentState)            
}

const getHtmlState = ()=>{
    return ''
}

/**
 * 
 * @param param0 
 */

export const Wys = ()=>{
    
    const { state, dispatch } = useContext(MessagesContext);
        
//     const [editorState, setEditorState] = React.useState(
//         EditorState.createWithContent(getContentState(contentRawHtml)),
// //        EditorState.createEmpty(),
//       );

      /**
       *onMount of the component , get the html from redux store, and load it to the editor state as internal format  
       * and save it in redux store under "SET_EDITOR_STATE"
       */
        useEffect(() => {
           // alert(`Wys: ${state.htmlBody}`)
            //if ((state.htmlBody !== null) && (state.htmlBody !== '') && state.loadSelectedItems) {
            if (state.loadSelectedItems) {
                const _initialEditorState = EditorState.createWithContent(getContentState(state.htmlBody))
                const _payload = { 
                    editorState: _initialEditorState
                }
                dispatch({ type: "SET_EDITOR_STATE", payload: _payload })

                // const _payloadHTML = { 
                //     htmlBody: null,
                //   }
                //   dispatch({ type: "SET_HTML_BODY", payload: _payloadHTML })

                //Reset the toggle value to be set again next time the user wants to push itsems to edito
            //  const _paylod = {
            //      loadSelectedItems: false 
            //    };
            //    dispatch({ type: "SET_EDIT_SELECTED_ITEMS", payload: _paylod });
        }
      }, [state.htmlBody, state.loadSelectedItems]) // this willclear the htmlBody on every change which is not desired for the last change before pushing to share
      // }, []) // this will apply only onmount


    const handleEditorStateChange = (newValue) => {
        //Save the editor state in the editor for UI operations as an update
        //setEditorState(editorState);    
        
        //Save the html version of the the editor state in redux store for keeping over component unmount
        const _payload = { 
            editorState: newValue
        }
        dispatch({ type: "SET_EDITOR_STATE", payload: _payload })

        //saves the html version of the richtext update to redux on every single update
        // this miigh not be very efficient yet it allows to share the updated html  to other components external to the ridhedit component, at any point
        // this specifically allows 'share' command button to copy the html vesrsion state.htmlBody to state.bodyContent
        // const rawContentState = convertToRaw(state.editorState.getCurrentContent());      
        
        const rawContentState = convertToRaw(newValue.getCurrentContent());      
       // alert(`rawContentState ${JSON.stringify(rawContentState)}`)
        const directional = false;
        const _bodyHtml = draftToHtml(
           rawContentState, 
           directional
        );


      //Reset the toggle value to be set again next time the user wants to push itsems to edito
             const _paylod = {
                 loadSelectedItems: false 
               };
               dispatch({ type: "SET_EDIT_SELECTED_ITEMS", payload: _paylod });
        const __payload = { 
            htmlBody: _bodyHtml
        }
        dispatch({ type: "SET_HTML_BODY", payload: __payload })
}
     
 
    
return (          
        <>
            <Editor
                editorState={state.editorState} //value from redux store
                wrapperClassName="wrapper-class"
                editorClassName="editor-class"
                toolbarClassName="toolbar-class"
                onEditorStateChange={(newValue)=>handleEditorStateChange(newValue)}
                toolbar={{
                    options: ['inline', 'list','textAlign','blockType','fontFamily','colorPicker', 'link', 'emoji', 'image'],
                    inline: { 
                        inDropdown: false,
                        options: ['bold', 'italic','underline']
                    },
                    list: { 
                        inDropdown: true, 
                        options: ['unordered', 'ordered']
                    },
                    
                    blockType: {
                        inDropdown: true,
                        options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6'],
                    },

                    fontFamily: {
                        inDropdown: true
                    },

                    textAlign: { 
                        inDropdown: true 
                    },        
                    link: { 
                        inDropdown: true 
                    },
                    history: { inDropdown: false },
                  }}
            />      

       
        </>
)

}




























     {/* <PrimaryButton 
                onClick={() => {handleUpdateShare()}} 
                style={{ marginRight: "8px" }}> 
                Update Share >>
            </PrimaryButton> */}